import useHttpHandler from "../../../hooks/httpHandler";
import {useEffect, useState} from "react";
import {toast} from "react-toastify";

const useProfile = () => {
    const [loading, setLoading] = useState(true)
    const [profileInfo, setProfileInfo] = useState(null)
    const [garagesList, setGaragesList] = useState([])
    const {get, put} = useHttpHandler()

    const getProfile = () => {
        setLoading(true)
        get('user/profile').then((res)=>{
            setProfileInfo(res.data)
            setLoading(false)
        }).catch(err => {
            setLoading(false)
        })
    }

    const updateProfile = (values, actions) => {
        put('user/profile', values).then((res)=>{
            actions.setSubmitting(false)
            toast.success('Profile updated successfully')

        }).catch(err => {
            actions.setSubmitting(false)
        })
    }

    const getGarages = () => {
        setLoading(true)
        get('garages').then((res)=>{
            const data = res.data
            setGaragesList(data.garages)
            getProfile()
        }).catch(err => {
            setLoading(false)
        })
    }

    useEffect(()=>{
        getGarages()
        getProfile()
    },[])

    return{
        loading,
        getProfile,
        profileInfo,
        updateProfile,
        garagesList
    }
}

export default useProfile